export default __webpack_public_path__ + "static/media/back4.ba880e90.jpg";